import { Link } from "react-router-dom";
import ta from "../../assets/TaxAmendments.png"
export default function Taxamendments() {
  return (
    <>
    {/* Spacer for sticky header */} 
      <div  />  {/* Header spacing style={{ height: 72 }}*/}

      {/* Hero Banner */}
      <section className="py-5 bg-white position-relative overflow-hidden">
        <div className="container py-4" data-aos="fade-left">
          <div className="row align-items-center gx-5">
            <div className="col-lg-7">
              <h1
                className="fw-bold mb-3"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  color: "#2e3d9c",
                  fontSize: "2.3rem",
                  lineHeight: 1.15,
                }}
              >
                Tax <span
                  style={{
                    background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                    color: "transparent",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text"
                  }}
                >Amendments</span>
              </h1>
              <p className="fs-5 text-secondary mb-1" style={{ maxWidth: 560 }}>
                Correct your tax returns with clarity and confidence. If you notice an error, missed deduction, or unreported income, a tax amendment keeps you compliant—and can even maximize your refund.
              </p>
            </div>
            <div className="col-lg-5 text-center d-none d-lg-block" data-aos="fade-right">
              <img
                src={ta}
                alt="Tax Amendment Illustration"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 270, objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
        {/* Decorative circles */}
        {/* <div
          aria-hidden="true"
          className="position-absolute top-0 end-0 opacity-15"
          style={{
            width: 110,
            height: 110,
            background: "linear-gradient(135deg, #6B46C1, #D53F8C)",
            borderRadius: "50%",
            filter: "blur(15px)",
          }} />
        </div>*/}
      </section>

      {/* What is a Tax Amendment? */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2
            className="fw-bold gradient-amend mb-4"
            style={{
              fontFamily: "'Poppins', sans-serif"
            }}
          >
            What is a Tax Amendment?
          </h2>
          <div className="row align-items-center gy-5">
            <div className="col-md-6">
              <div className="card border-0 shadow h-100 p-4 rounded-4">
                <span
                  className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-52"
                  style={{ background: "#e1e2fa" }}
                >
                  <i className="bi bi-pencil-square fs-2 text-primary"></i>
                </span>
                <div className="fs-6 text-secondary mb-2">
                  A <b>Tax Amendment</b> is the official process for correcting or updating a tax return you’ve already filed.
                  <br /><br />
                  If you discover an error, missed deduction, or overlooked income, you can file an amendment to fix the mistake. The most common form for this is <b>IRS Form 1040X</b> for individual tax returns. Businesses may use additional forms as required for their legal structure.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card border-0 shadow h-100 p-4 rounded-4">
                <span
                  className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-52"
                  style={{ background: "#fae1f2" }}
                >
                  <i className="bi bi-card-checklist fs-2" style={{ color: "#d53f8c" }}></i>
                </span>
                <div className="fs-6 text-secondary mb-2">
                  Not sure if you need to amend? If you receive new information after filing—like a forgotten W-2, corrected 1099, or a deduction you missed—it’s time to review your return.<br />
                  <span className="fw-semibold">We’ll help you analyze your situation, decide if an amendment is necessary, and ensure all forms are properly completed and submitted.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* When Should You File an Amendment? */}
      <section className="py-5" style={{ background: "#fff" }}>
        <div className="container">
          <h3
            className="fw-bold mb-4 gradient-amend"
            style={{
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            When Should You File an Amendment?
          </h3>
          <div className="row g-4">
            {[
              {
                icon: "bi bi-exclamation-triangle",
                iconColor: "#D53F8C",
                title: "Found a Mistake",
                desc: "You discovered an error in your income, filing status, or deduction after submitting your return."
              },
              {
                icon: "bi bi-cash-stack",
                iconColor: "#6B46C1",
                title: "Missed Income or Deductions",
                desc: "You forgot to include income, a W-2, a 1099, or didn’t claim a tax deduction/credit you qualified for."
              },
              {
                icon: "bi bi-arrow-up-circle",
                iconColor: "#224eae",
                title: "Received IRS or State Letter",
                desc: "You’ve received notice about a discrepancy or adjustment from the IRS or state authority."
              },
              {
                icon: "bi bi-journal-check",
                iconColor: "#31926A",
                title: "Need to Update Filing Info",
                desc: "Your original filing status or dependents have changed and need correction."
              }
            ].map(({ icon, iconColor, title, desc }) => (
              <div className="col-sm-6 col-lg-3" key={title}>
                <div className="card border-0 shadow-sm h-100 text-center p-4 rounded-4">
                  <span className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-44" style={{ background: "#f7f2fa" }}>
                    <i className={`${icon} fs-2`} style={{ color: iconColor }}></i>
                  </span>
                  <h6 className="fw-semibold mb-2" style={{ color: iconColor }}>{title}</h6>
                  <p className="small text-secondary mb-0">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact & Action Section */}
      <section
        className="py-5 text-center"
        style={{ background: "#f8fafe" }}
      >
        <div className="container">
          <h3
            className="fw-bold mb-3 gradient-amend"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Need to File a Tax Amendment?
          </h3>
          <p className="fs-5 text-secondary mb-4" style={{ maxWidth: 620, margin: "0 auto" }}>
            If you’ve made a mistake on your tax return or want to ensure you’re filing correctly,
            <b> Nexen Consulting’s professionals are here to help.</b> Contact us for a consultation—we’ll guide you through every step and help you correct your return with confidence.
          </p>
          <div className="d-flex justify-content-center">
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
              style={{
                background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                boxShadow: "0 4px 15px rgba(213,63,140,0.45)",
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(213,63,140,0.65)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(213,63,140,0.45)";
              }}
            >
              Get Help with Amendments
            </Link>
          </div>
        </div>
      </section>

      {/* Custom CSS */}
      <style>{`
        .gradient-amend {
          background: linear-gradient(90deg, #6B46C1, #D53F8C);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
        }
      `}</style>

      {/* Bootstrap Icons (CDN fallback) */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />

    </>
  );
}
